export const CANNOT_CREATE = 'app/CANNOT_CREATE';
export const CANNOT_UPDATE = 'app/CANNOT_UPDATE';
export const CANNOT_UPLOAD = 'app/CANNOT_UPLOAD';
export const CANNOT_REMOVE = 'app/CANNOT_REMOVE';
export const CANNOT_ADD = 'app/CANNOT_ADD';
export const CANNOT_ACTIVATE = 'app/CANNOT_ACTIVATE';
export const CANNOT_DEACTIVATE = 'app/CANNOT_DEACTIVATE';
export const CANNOT_RESTORE = 'app/CANNOT_RESTORE';
